import FunctionsData from "./FunctionsData";

export default class FunctionsConfig {
	
	constructor() {
	
	}
	
	static getAnimalTypes() {
		return ['Cat'];
	}
	
	static getAges() {
		return [
			'Less than 4 months',
			'4-6 months',
			'6-12 months',
			'1-5 years',
			'5 years plus',
			'Unknown'
		]
	}
	
	static getReasonsSource() {
		return ['My pet', 'A stray in my neighbourhood', 'Part of a colony', 'On behalf of owner'];
	}
	
	static getReasonsSourceRequireConfirmation() {
		return ['On behalf of owner'];
	}
	
	static getReasonsSourceRequireNotification() {
		return ['Part of a colony','A stray in my neighbourhood'];
	}
	
	static getTypeOfSurgery() {
		return ['Neuter', 'Cryptorchid', 'Spay', 'Pregnant spay'];
	}
	
	static getTypeOfSurgeryByType(type) {
		if (String(type).toLowerCase() === 'male') {
			return ['Neuter', 'Cryptorchid'];
		} else {
			return ['Spay', 'Pregnant spay'];
		}
	}
	
	
	
	// static pricingMatrix() {
	// 	return [
	// 		{type: "cat", gender: "male", a_type_surgery: "neuter", price: 50, pregnant_add: 0},
	// 		{type: "cat", gender: "male", a_type_surgery: "cryptorchid", price: 110, pregnant_add: 0},
	// 		{type: "cat", gender: "male", a_type_surgery: "spay", price: 50, pregnant_add: 0},
	// 		{type: "cat", gender: "male", a_type_surgery: "pregnant spay", price: 120, pregnant_add: 0},
	// 		{type: "cat", gender: "female", a_type_surgery: "spay", price: 110, pregnant_add: 0},
	// 		{type: "cat", gender: "female", a_type_surgery: "pregnant spay", price: 120, pregnant_add: 0},
	// 		{type: "cat", gender: "female", a_type_surgery: "neuter", price: 110, pregnant_add: 0},
	// 		{type: "cat", gender: "female", a_type_surgery: "cryptorchid", price: 110, pregnant_add: 0},
	// 	]
	// }

	static async pricingMatrix(animal_type,animal_gender,animal_weight,animal_surgery,community=false) {

		console.log('pricingMatrix',community)
		const api = (community === true) ? "/api/config/pricing-community" : "/api/config/pricing";

		return await fetch(FunctionsData.getApiUrl(api), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'token': FunctionsData.getSessionToken()
			},
			body: JSON.stringify({
				animal_type:animal_type,
				animal_gender:animal_gender,
				animal_weight:animal_weight,
				animal_surgery:animal_surgery
			})
		})
			.then((res) =>  res.json())
			.then((d) => {
				console.log(d.data);
				return d.data;
			})
			.catch((err) => {
				return false;
			}) ;

	}
	
	static lang() {
		return this.l();
	}
	
	static l() {
		
		return {
			'': ''
		};
		
	}
	
	static async getPrimaryColours(species='Cat') {
		return await fetch(FunctionsData.getApiUrl('/api/config/colours'), {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'token': FunctionsData.getSessionToken()
			}
		})
			.then((res) =>  res.json())
			.then((d) => {
				console.log(d);
				let cols = [];
				try {
					d.data[species].forEach((x) => {
						cols.push(x.label)
					});
				} catch (e) {
					//
				}
				return cols;
			});
		
	}
	
	static async getAnimalTypesArray() {

		return await fetch(FunctionsData.getApiUrl('/api/config/species-community'), {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'token': FunctionsData.getSessionToken()
			}
		})
			.then((res) =>  res.json())
			.then((d) => {
				console.log(d);
				let cols = [];
				try {
					d.data.forEach((x) => {
						cols.push(x.label)
					});
				} catch (e) {
					//
				}
				return cols;
			});
	}

	static async getReasonsSource(animal_type = 'Cat') {
		if(animal_type === 'Dog') {
			return ['My pet', 'On behalf of owner'];
		}
		return ['My pet', 'A stray in my neighbourhood', 'Part of a colony', 'On behalf of owner'];
	}
	
	static getReasonsSourceRequireConfirmation() {
		return ['On behalf of owner'];
	}
	
	static getReasonsSourceRequireNotification() {
		return ['Part of a colony','A stray in my neighbourhood'];
	}
	
	static getTypeOfSurgery() {
		return ['Neuter', 'Cryptorchid', 'Spay', 'Pregnant spay'];
	}
	
	static getTypeOfSurgeryByType(type) {
		if (String(type).toLowerCase() === 'male') {
			return ['Neuter', 'Cryptorchid'];
		} else {
			return ['Spay', 'Pregnant spay'];
		}
	}
	
	static getGenders() {
		return ['Unknown', 'Male', 'Female'];
	}
	
	static getGendersVet() {
		return ['Male', 'Female'];
	}
	
	// static pricingMatrix() {
	// 	return [
	// 		{type: "cat", gender: "male", a_type_surgery: "neuter", price: 50, pregnant_add: 0},
	// 		{type: "cat", gender: "male", a_type_surgery: "cryptorchid", price: 110, pregnant_add: 0},
	// 		{type: "cat", gender: "male", a_type_surgery: "spay", price: 50, pregnant_add: 0},
	// 		{type: "cat", gender: "male", a_type_surgery: "pregnant spay", price: 120, pregnant_add: 0},
	// 		{type: "cat", gender: "female", a_type_surgery: "spay", price: 110, pregnant_add: 0},
	// 		{type: "cat", gender: "female", a_type_surgery: "pregnant spay", price: 120, pregnant_add: 0},
	// 		{type: "cat", gender: "female", a_type_surgery: "neuter", price: 110, pregnant_add: 0},
	// 		{type: "cat", gender: "female", a_type_surgery: "cryptorchid", price: 110, pregnant_add: 0},
	// 	]
	// }


	static async getWeights() {

		return await fetch(FunctionsData.getApiUrl('/api/config/weights'), {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'token': FunctionsData.getSessionToken()
			}
		})
			.then((res) =>  res.json())
			.then((d) => {
				console.log(d);
				let cols = [];
				try {
					d.data.forEach((x) => {
						cols.push(x.label)
					});
				} catch (e) {
					//
				}
				return cols;
			})
			.catch((err) => {
				return [];
			}) ;
	}

	static async getSecondaryColours(species='Cat') {
		
		return await fetch(FunctionsData.getApiUrl('/api/config/colours'), {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'token': FunctionsData.getSessionToken()
			}
		})
			.then((res) =>  res.json())
			.then((d) => {
				console.log(d);
				let cols = [];
				try {
					d.data[species].forEach((x) => {
						cols.push(x.label)
					});
				} catch (e) {
					//
				}
				return cols;
			});
	}
}